/**
 * Tracks the last non-Settings route the user visited, so the in-app
 * feedback form can default `page_path` to "where the report is actually
 * about" instead of always sending "/settings". Module-level state (same
 * pattern as components/Toast.tsx) — cheap, no store/context needed since
 * only AppLayout writes it and SettingsPage reads it once on mount.
 */

let lastNonSettingsPath: string | null = null;

export function recordVisitedPath(pathname: string) {
  if (pathname === '/settings') return;
  lastNonSettingsPath = pathname;
}

export function getLastNonSettingsPath(): string | null {
  return lastNonSettingsPath;
}
